"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useWebChatUIContext;

var _react = require("react");

var _WebChatUIContext = _interopRequireDefault(require("./WebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useWebChatUIContext() {
  var context = (0, _react.useContext)(_WebChatUIContext.default);

  if (!context) {
    throw new Error('This hook can only be used on a component that is a descendant of <Composer>');
  }

  return context;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VXZWJDaGF0VUlDb250ZXh0LmpzIl0sIm5hbWVzIjpbInVzZVdlYkNoYXRVSUNvbnRleHQiLCJjb250ZXh0IiwiV2ViQ2hhdFVJQ29udGV4dCIsIkVycm9yIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRUE7Ozs7QUFFZSxTQUFTQSxtQkFBVCxHQUErQjtBQUM1QyxNQUFNQyxPQUFPLEdBQUcsdUJBQVdDLHlCQUFYLENBQWhCOztBQUVBLE1BQUksQ0FBQ0QsT0FBTCxFQUFjO0FBQ1osVUFBTSxJQUFJRSxLQUFKLENBQVUsOEVBQVYsQ0FBTjtBQUNEOztBQUVELFNBQU9GLE9BQVA7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlQ29udGV4dCB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IFdlYkNoYXRVSUNvbnRleHQgZnJvbSAnLi9XZWJDaGF0VUlDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlV2ViQ2hhdFVJQ29udGV4dCgpIHtcbiAgY29uc3QgY29udGV4dCA9IHVzZUNvbnRleHQoV2ViQ2hhdFVJQ29udGV4dCk7XG5cbiAgaWYgKCFjb250ZXh0KSB7XG4gICAgdGhyb3cgbmV3IEVycm9yKCdUaGlzIGhvb2sgY2FuIG9ubHkgYmUgdXNlZCBvbiBhIGNvbXBvbmVudCB0aGF0IGlzIGEgZGVzY2VuZGFudCBvZiA8Q29tcG9zZXI+Jyk7XG4gIH1cblxuICByZXR1cm4gY29udGV4dDtcbn1cbiJdfQ==